module.exports = __webpack_public_path__ + "img/calendario-2023.d0ab1c6f.jpg";